import { FollowArrivals } from '@app/models';
import {
  FollowArrivalActionTypes,
  FollowArrivalActionsUnion
} from '@core/actions/follow-arrivals.actions';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<FollowArrivals>{
    loading: boolean;
    loaded: boolean;
    spinnerMessage: string;
}

export const adapter: EntityAdapter<FollowArrivals> = createEntityAdapter<FollowArrivals>({
    selectId: (followArrival: FollowArrivals) => followArrival.id
})

export const INITIAL_STATE: State = adapter.getInitialState({
    loading: false,
    loaded: false,
    busy: false,
    spinnerMessage: null
})

export function reducer(
    state: State = INITIAL_STATE,
    action: FollowArrivalActionsUnion
){
    switch(action.type){
        case FollowArrivalActionTypes.Load:
        case FollowArrivalActionTypes.FollowAddArrival:
        case FollowArrivalActionTypes.FollowArrivalUpdate:
        case FollowArrivalActionTypes.FollowArrivalDelete:
          return { ...state, loading: true }
        
        case FollowArrivalActionTypes.LoadSuccess:
          return adapter.addAll(action.data, {
            ...state,
            loading: false,
            loaded: true
          })

        case FollowArrivalActionTypes.FollowAddArrivalSuccess:
          return adapter.addOne(action.data, {
            ...state,
            loading: false,
            loaded: true
          })

        case FollowArrivalActionTypes.FollowArrivalUpdateSuccess:
          return adapter.updateOne(
            {id: action.data.id, changes: action.data},
            {
              ...state,
              loading: false,
              loaded: true
            }
          );

        case FollowArrivalActionTypes.FollowArrivalDeleteSuccess:
          console.log('action => ',action.arrivalId)
          return adapter.removeOne(action.arrivalId, {
            ...state,
            loading: false,
            loaded: true
          })

        case FollowArrivalActionTypes.FollowArrivalUpdateFail:
        case FollowArrivalActionTypes.FollowAddArrivalFail:
        case FollowArrivalActionTypes.LoadFail:
        case FollowArrivalActionTypes.FollowArrivalDeleteFail:
          return {
            ...state,
            loading: false,
            spinnerMessage: 'Error al traer los Arrivos!'
          }

        default: 
        return state;
    }
}

const {
    selectAll,
  } = adapter.getSelectors();

  export const getState = createFeatureSelector<State>('followArrivals');

export const selectLoading = (state: State) => state.loading;
export const selectSpinnerMessage = (state: State) => state.spinnerMessage;

export const getAll = createSelector(
    getState,
    selectAll
  );

  export const getLoading = createSelector(
    getState,
    selectLoading
  );
  
  export const getSpinnerMessage = createSelector(
    getState,
    selectSpinnerMessage
  )